<sc-flex [fitHeight]="true" [stretchContent]="true" [vertical]="true">
    <sc-flex [stretchContent]="true">
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="copyLogToClipboard()"
            [matTooltip]="'copy to clipboard' | translate: ['tmc.personalvisit.dialog.protocol.action.copy-to-clipboard', translationService.language]">
            <sc-icon iconClass="fa-copy"></sc-icon>
        </button>
    </sc-flex>
    <sc-flex-fitting-content [vertical]="true">
        <sc-scroll-pane>
            <table class="table" *ngIf="visit" style="border-spacing: 16px;">
                <tr *ngFor="let entry of logEntries" class="text-selection">
                    <td class="text-selection" style="white-space: nowrap;">
                        {{entry.timestamp}}
                    </td>
                    <td>
                        {{entry.displayText}}
                    </td>
                </tr>
            </table>
        </sc-scroll-pane>
    </sc-flex-fitting-content>
</sc-flex>